import axios from "axios";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://scurryllp-001-site12.htempurl.com/api";

const api = axios.create({
  baseURL: "https://scurryllp-001-site12.htempurl.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
